export const GUEST_EMAIL = 'guest_email';

export default GUEST_EMAIL;
